// TODO: These types are suppose to move to conv-ui types
export type TCategoryContextTemplate = 'mainInfo' | 'listingInfo';

export enum CategoryInfoObject {
  'listingInfo' = 'listingInfo',
  'mainInfo' = 'mainInfo',
}

export enum CategoryContextTemplate {
  'listing' = 'category listing',
  'category' = 'category',
}

export enum SubcategoryContextTemplate {
  'listing' = 'subcategory listing',
  'subcategory' = 'subcategory',
}
